<template>
  <div class="login" flex="dir:top">
    <div class="header">
      <img alt="cystron" src="~@/assets/logo.png" style="margin-left:10px;width:100px;height:38px;" />
    </div>
    <div class="main" flex="main:center cross:center" flex-box="1">
      <el-form ref="loginForm" class="form card" :model="loginForm" :rules="rules">
        <div class="title">Login</div>
        <el-form-item prop="username" label="Username">
          <el-input v-model="loginForm.username"></el-input>
        </el-form-item>
        <el-form-item prop="password" label="Password">
          <el-input type="password" v-model="loginForm.password" @keyup.enter.native="login"></el-input>
        </el-form-item>
        <el-form-item prop="password2" label="Company ID">
          <el-input type="password" v-model="loginForm.password2" @keyup.enter.native="login"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="login" :loading="loading">Login</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loginForm: {
        username: '',
        password: '',
        password2: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    login () {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('login', {
            vm: this,
            username: this.loginForm.username,
            password: this.loginForm.password,
            password2: this.loginForm.password2
          }).then(() => this.loading = false)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.login {
  min-height: 100vh;
  background: #d3d4d7;
  .header {
    background: #c3daff;
    border-bottom: 1px solid #d9dee4;
    text-align: center;
    height: 42px;
    line-height: 42px;
    font-size: 18px;
    font-weight: bold;
    box-shadow: 0 1px 2px 0 rgba(0,0,0,.2), 0 1px 1px -2px rgba(0,0,0,.14), 0 1px 4px 0 rgba(0,0,0,.12);
  }
  .main {
    .form {
      width: 420px;
      background: #fff;
      .title {
        font-size: 24px;
        font-weight: 500;
        padding: 20px 0;
        text-align: center;
      }
      .el-input__inner {
        height: 40px;
        border-radius: 4px;
        padding: 0 15px;
      }
      .el-button {
        padding: 12px 20px;
        border-radius: 4px;
      }
    }
  }
}
</style>
